export default __webpack_public_path__ + "static/media/senegal.0aea3bc2.svg";